<template>
  <div class="tool-item2">
    <el-dialog
      class="newDialog"
      title="取之不盡"
      :visible.sync="visible"
      height="100%"
      :before-close="handleClose"
    >
      <div class="brandFilter">
        <el-checkbox-group
          :min="1"
          v-model="brandList"
          @change="getTreelist"
          class="brand-checkbox"
        >
          <el-checkbox label="TutorABC">
            <img src="../../assets/TutorABC.png" alt />
          </el-checkbox>
          <el-checkbox label="tutorJr" class="isJr">
            <img src="../../assets/tutorJr.png" alt />
          </el-checkbox>
        </el-checkbox-group>
      </div>

       <div v-if="this.fileList&&this.fileList.length">
        <span @mouseover="hover = true" @mouseleave="hover = false">已選擇{{this.fileList.length}}項素材</span>
        <span v-if="hover" >素材清單:{{JSON.stringify(this.fileList.map(e=>e.filename))}}</span>
        <el-button @click="sendFileList()">批次送出</el-button>
        <el-button @click="clearFileList()">清空素材清單</el-button>
       </div>

      <div class="newList touch_css">
        <div class="breadcrumbAttachFile">
          <a @click="breadcrumbClick(item)" v-for="(item, index) in Breadcrumb">
            <img src="../../assets/arrow-tail.svg" alt class="notLast" />
            <img src="../../assets/arrow-tail-l.svg" alt class="istLast" />
            {{item.name}}
            <img src="../../assets/arrow-head.svg" alt class="notLast" />
            <img src="../../assets/arrow-head-l.svg" alt class="istLast" />
          </a>
        </div>
        <el-input
          id="attachFileContentfilter"
          placeholder="輸入關鍵字進行過濾"
          v-model="SearchText"
          @keyup.enter.native="attachFileContentfilter"
        ></el-input>
        <div v-show="!contentShow">
          <ul>
            <li
              :class="[item.ThumbnailUrl=== '' ? 'withoutImg' : '' ]"
              v-for="(item, index) in newoptions"
              @click="nodeClick(item)"
            >
              <div class="thumb_img" v-if="item.ThumbnailUrl!== ''">
                <img :src="item.ThumbnailUrl" alt />
              </div>
              <span>{{item.NodeName}}</span>
              <img class="hasNext" src="../../assets/next.png" alt />
            </li>
          </ul>
        </div>
        <div v-show="contentShow">
          <ul class="noNext">
            <li
              :class="[item.thumbnailUrl=== '' ? 'withoutImg' : '' ]"
              v-for="(item, index) in tableData.filter(data => !search || data.filename.toLowerCase().indexOf(search.toLowerCase())>=0)"
              @click="preview(item)"
            >
              <div class="thumb_img" v-if="item.thumbnailUrl!== ''">
                <img :src="item.thumbnailUrl" alt />
              </div>
              <span>{{item.filename}}</span>
            </li>
          </ul>
        </div>
      </div>




    </el-dialog>
    <el-dialog
      title="預覽"
      class="newDialog previewFile"
      :visible.sync="previewvisable"
      :before-close="handleClose"
    >
      {{selectrow.content}}
      <div v-if="selectrow.type=='Image'">
        <br />
        <br />
        <a target="_blank" :href="selectrow.path" class="imgPreview">
          <img :src="selectrow.previewImageUrl" />
        </a>
      </div>
      <div v-if="selectrow.type=='File'">
        <br />
        <a :href="selectrow.path">
          <img src="../../assets/file.png" width="24" height="24" />
          {{selectrow.filename}}
        </a>
      </div>
      <div v-if="selectrow.type=='Video'">
        <br />
        <a :href="selectrow.previewVideoUrl" target="_blank" rel="noreferrer noopener" style="width: 100%; text-align: center;">
          點此預覽影片
        </a>
        <!--
        <video controls width="250">
            <source :src="selectrow.previewVideoUrl"
                    type="video/mp4">
        </video>
        -->
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button v-if="!(this.fileList&&this.fileList.length)" type="primary" @click="selectFile(selectrow)">送 出</el-button>
        <el-button v-if="this.fileList&&this.fileList.length" @click="sendFileList(selectrow)">加入清單並送出</el-button>
        <el-button v-if="!(this.fileList&&this.fileList.length)" @click="addFileList(selectrow)">加入素材清單</el-button>
        <el-button v-if="this.fileList&&this.fileList.length" @click="addFileList(selectrow)">加入清單並繼續選擇</el-button>
        <el-button v-if="this.fileList&&this.fileList.length" @click="clearFileList()">清空素材清單</el-button>
        <el-button @click="previewvisable = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Global from "@/components/Global";
import { AttachFileHandler } from "@/handler/AttachFileHandler.js";
import http from "../../http.js";
import qs from "qs";

export default {
  data() {
    return {
      visible: false, //附檔dialog顯示
      tableData: [], //內文檔案資料
      previewvisable: false,
      selectrow: [], //內文選擇列
      fileList: [], //多選清單
      brandList: ["TutorABC", "tutorJr"], //品牌選擇
      options: [], //所有目錄結構
      newoptions: [],
      Breadcrumb: [],
      SearchText: "", //目錄搜尋值
      contentShow: false
    };
  },
  methods: {
    attachFileContentfilter(event) {
      if ($("#attachFileContentfilter").val() != this.SearchText) {
        return;
      }
      var searchNodeText = this.SearchText;
      //初始化
      this.iniData(this.brandList);

      if (searchNodeText == "") {
        return;
      }

      this.SearchNodeText = searchNodeText;
      // this.tableData = AttachFileHandler.GetContentFilter(
      //   searchNodeText,
      //   this.brandList
      // );
      http
        .post(
          "Chat/GetContentFilter",
          qs.stringify({
            brand: this.brandList,
            staffId: Global.current_staffid,
            searchText: searchNodeText
          })
        )
        .then(response => {
          this.tableData = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
      this.contentShow = true;
    },
    iniData(brand) {
      if (brand.length == 0) {
        brand = ["TutorABC", "tutorJr"];
      }
      this.visible = true;
      this.tableData = [];
      this.search = "";
      this.Breadcrumb = [];
      this.Breadcrumb.push({ name: "ROOT", value: "ROOT" });

      this.options = AttachFileHandler.GetContentNodeTree(brand);
      this.newoptions = this.options;
      this.contentShow = false;
      this.SearchText = "";

      // 取之不盡：
      // 頂層只有單一節點：麵包屑 ROOT > Root
      // 空值（null / []）或多頂層：ROOT
      if (
        this.options &&
        this.options.length === 1 &&
        this.options[0].Children &&
        this.options[0].Children.length > 0
      ) {
        this.nodeClick(this.options[0]);
      }
    },
    breadcrumbClick(node) {
      this.SearchText = "";
      let vm = this;
      vm.contentShow = false;
      vm.search = "";
      var newBreadcrumb = [];
      newBreadcrumb.push({ name: "ROOT", value: "ROOT" });

      if (node.value == "ROOT") {
        vm.newoptions = vm.options;
        vm.Breadcrumb = newBreadcrumb;
        return;
      }

      //處理導覽
      for (var i = 1; i <= vm.Breadcrumb.length - 1; i++) {
        newBreadcrumb.push(vm.Breadcrumb[i]);
        if (vm.Breadcrumb[i] === node) {
          break;
        }
      }
      vm.Breadcrumb = newBreadcrumb;

      //處理子目錄
      vm.newoptions = vm.options;
      for (var i = 1; i <= vm.Breadcrumb.length - 1; i++) {
        var filter = vm.newoptions.filter(
          data => data.NodeName == vm.Breadcrumb[i].value
        );

        if (filter.length > 0 && filter[0].Children.length > 0) {
          vm.newoptions = filter[0].Children;
        }
      }
    },
    nodeClick(item) {
      let vm = this;
      vm.Breadcrumb.push({
        name: item.NodeName,
        value: item.NodeName
      });
      var filter = vm.newoptions.filter(data => data.NodeName == item.NodeName);
      if (filter.length > 0 && filter[0].Children.length > 0) {
        vm.newoptions = filter[0].Children;
      }

      vm.tableData = [];
      vm.filecount = item.NodeName;

      vm.tableData = AttachFileHandler.GetContentByNodeId(
        item.Id,
        vm.brandList
      );
      vm.contentShow = vm.tableData.length > 0;
    },

    handleClose(done) {
      done();
    },
    selectFile(row) {
      AttachFileHandler.SendContentMessage(row.id);
      this.visible = false;
      this.previewvisable = false;
    },
    addFileList(row) {
      this.fileList.push(row);
      this.previewvisable = false;
    },
    sendFileList(row) {

      if(row)
      {
        this.fileList.push(row);
      }

     this.fileList.filter(function(elem) {
           AttachFileHandler.SendContentMessage(elem.id);
        });

      this.visible = false;
      this.previewvisable = false;
      this.fileList = [];
    },
    clearFileList() {
      this.fileList = [];
    },
    preview(row) {
      this.previewvisable = true;
      this.selectrow = row;
    },

    getTreelist(brand) {
      this.iniData(brand);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.NodeName.indexOf(value) !== -1;
    }
  }
};
</script>
 <style>
.touch_css {
  -webkit-overflow-scrolling: touch;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/ChatToolBar_AttachFile.vue